import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode, getTemplateNodeReturns, externalId} from "@cm/template-nodes"
import type {TemplateNodeDefinition, BuilderInlet, GraphBuilderScope, NodeEvaluator} from "@cm/template-nodes"
import type {MattressComponentInstance} from "#mattress/nodes/component/mattress-component-instance"
import {MattressOutput, type MattressOutputParameters} from "#mattress/nodes/mattress-output"
import type {MattressCurveData} from "#mattress/nodes/curve/mattress-curve"
import {mattressCurveLikeMarker} from "#mattress/role-markers"
import type {MattressCurveLikeNode} from "#mattress/role-markers"

export type MattressCurveOutputParameters = MattressOutputParameters

const definition: TemplateNodeDefinition<MattressCurveOutputParameters> = {
    nodeClass: "MattressCurveOutput",
    validation: {
        parameters: z.object({
            name: z.string(),
            component: graphNode<MattressComponentInstance>("MattressComponentInstance"),
            outputId: externalId,
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MattressCurveOutput extends MattressOutput implements MattressCurveLikeNode {
    get [mattressCurveLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<MattressCurveData | null> {
        return this.evaluateComponentOutput<MattressCurveData>("mattressCurve", scope, evaluator)
    }
}
